define('plugin/invoice/controller/InvoiceController',['require','lib/controller/BaseController','plugin/invoice/view/InvoiceLayout','plugin/invoice/view/InvoiceListView','plugin/invoice/collection/InvoiceCollection','plugin/invoice/model/InvoiceModel','model/ClientModel','plugin/paid-events/model/PaymentSystemModel','lib/terms/ClientTermsController','lib/plugin/PluginBroker','lib/Utils'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var InvoiceLayout = require('plugin/invoice/view/InvoiceLayout');
    var InvoiceListView = require('plugin/invoice/view/InvoiceListView');

    var InvoiceCollection = require('plugin/invoice/collection/InvoiceCollection');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');
    var ClientModel = require('model/ClientModel');
    var PaymentSystemModel = require('plugin/paid-events/model/PaymentSystemModel');
    var ClientTermsController = require('lib/terms/ClientTermsController');

    var PluginBroker = require('lib/plugin/PluginBroker');
    var Utils = require('lib/Utils');

    /**
     * Invoice Controller
     *
     * @class InvoiceController
     */
    return BaseController.extend({

        _invoiceLayout: null,
        _invoiceModel: null,
        _paymentSystemCollection: null,
        _paymentMethodCollection: null,
        _paymentProcessor: null,

        _timeout: 5000,
        _timer: null,

        initialize: function () {
            this._paymentSystemCollection = this.getOption('paymentSystemCollection');
            this._paymentMethodCollection = this.getOption('paymentMethodCollection');
            this._clientModel = this.getOption('clientModel');

            BaseController.prototype.initialize.apply(this);
        },

        pay: function (id, isReturn, isDirectLink, code) {
            this._invoiceModel = new InvoiceModel({id: id, code: code});
            this._invoiceModel.fetch({
                data: {
                    code: code
                }
            });

            this.listenTo(this._invoiceModel, 'sync', _.bind(function (model, data) {
                if (data.id) {
                    this._viewInvoice(id, isReturn, this._invoiceModel.isPaymentAllowed(), isReturn ? 'return' : 'pay', isDirectLink);
                }
            }, this));
        },

        view: function (id) {
            this._invoiceModel = new InvoiceModel({id: id});
            this._invoiceModel.fetch();

            this.listenTo(this._invoiceModel, 'sync', _.bind(function () {
                this._viewInvoice(id, false, false, 'view');
            }, this));
        },

        list: function (page) {
            var collection = new InvoiceCollection();
            collection.getPager().setPage(page);

            this.listenTo(collection, 'sync', _.bind(function () {
                var listView = new InvoiceListView({
                    collection: collection,
                    label: 'invoices_list',
                    url: 'invoice/list/page/:page'
                });

                this.getMainLayout().getContentRegion().show(listView);
            }, this));
        },

        _viewInvoice: function (id, isReturn, paymentAllowed, viewMode, isDirectLink) {
            this._invoiceLayout = new InvoiceLayout({
                paymentSystemCollection: this._paymentSystemCollection,
                paymentMethodCollection: this._paymentMethodCollection,
                invoiceModel: this._invoiceModel,
                clientModel: this._clientModel,
                paymentAllowed: paymentAllowed && !isReturn,
                isReturn: isReturn,
                viewMode: viewMode,
                isDirectLink: isDirectLink,
            });

            this.listenTo(this._invoiceLayout, 'payment_processor:select', this._setPaymentProcessor);
            this.listenTo(this._invoiceLayout, 'payment_processor:recurring', this._setRecurringFlag);
            this.listenTo(this._invoiceLayout, 'payment_processor:rebilling', this._setRebillingFlag);
            this.listenTo(this._invoiceLayout, 'payment_processor:pay', this._payInvoice);
            this.listenTo(this._invoiceLayout, 'payment_processor:pay:free', this._payFreeInvoice);
            this.listenTo(this._invoiceLayout, 'payment_processor:loaded', this._paymentProcessorLoaded);
            this.listenTo(this._invoiceLayout, 'destroy', _.bind(function () {
                if (this._timer) {
                    clearTimeout(this._timer);
                }
            }, this));

            this.getMainLayout().getContentRegion().show(this._invoiceLayout);

            if (!isReturn && paymentAllowed) {
                this.listenTo(this._paymentSystemCollection, 'sync', this._autoSelectPaymentProcessor);

                if (this._paymentSystemCollection.length) {
                    this._autoSelectPaymentProcessor();
                }
            }

            var _this = this;
            this.listenTo(this._paymentSystemCollection, 'sync', function () {
                _this._onInvoiceShown(isReturn, paymentAllowed);
            });

            this._onInvoiceShown(isReturn, paymentAllowed);

            this._paymentSystemCollection.resetFilters();
            if (this._invoiceModel.get('require_recurring_payment_method')) {
                this._paymentSystemCollection.addFilter(function (model) { return model.get('supports_recurring') });
                this._paymentMethodCollection.addFilter(function (model) { return model.get('supports_recurring') });
            }

            this._paymentSystemCollection.load();
            this._paymentMethodCollection.reload();
        },

        _paymentProcessorLoaded: function (paymentProcessor) {
            if (paymentProcessor.get('is_delay')) {
                this._invoiceLayout.displayButtons(true);

                PluginBroker.getInstance().perform('onFinishPayment', [this._invoiceLayout, {
                    id: this._invoiceModel.id,
                    booking_ids: this._invoiceModel.getBookingIds(),
                    payment_processor: this._invoiceModel.get('payment_processor')
                }, this._invoiceModel]);
            }
        },

        _autoSelectPaymentProcessor: function () {
            if (this._invoiceModel.get('amount') === 0) return;

            var paymentSystemsWithoutDelay = this._paymentSystemCollection.filter(function (m) {
                return m.get('id') !== 'delay';
            });

            var isPaid = this._invoiceModel.get('status') === 'paid';
            var isDepositNoPayLater = this._invoiceModel.get('is_with_deposit_amount') && !this._invoiceModel.get('deposit_is_client_can_pay_later');
            var disableDelay = isPaid || isDepositNoPayLater;

            if (this._paymentSystemCollection.length === 1) {
                this._setPaymentProcessor({model: this._paymentSystemCollection.first()});
            } else if (disableDelay && paymentSystemsWithoutDelay.length === 1) {
                this._setPaymentProcessor({model: this._paymentSystemCollection.find(function (m) {
                    return m.get('id') !== 'delay'
                })});
            } else if (this._paymentProcessor) {
                if (this._paymentProcessor.id === 'delay' && disableDelay) {
                    this._setPaymentProcessor({model: null});
                } else {
                    this._setPaymentProcessor({model: this._paymentProcessor});
                }
            } 
        },

        _acceptTerms : function (invoiceModel){
            var lines = invoiceModel.get('lines');
            var isPromoInvoice = false;

            if(lines) {
                lines.each(function (line) {
                    //console.log(line.get('type'));
                    if (line.get('type') == 'promotion') {
                        isPromoInvoice = true;
                    }
                });

                if (isPromoInvoice) {
                    this._termsController = ClientTermsController.getInstance({
                        'client': this._clientModel
                    });
                    this._clientModel.saveClientTerms(this._termsController.getModel().getAcceptedTermsWithoutPromoFlags());
                }
            }
        },

        _payInvoice: function () {
            this._acceptTerms(this._invoiceModel);
            this._invoiceLayout.hideRecurringFlag();
            this._invoiceLayout.hideRebillingFlag();

            if (this._getPaymentProcessor()) {
                this._invoiceLayout.displayPayProcess(this._invoiceModel, this._getPaymentProcessor());

                this._getPaymentProcessor().set('selected', false);
                this._paymentProcessor = null;

                this._invoiceLayout.hidePromotionRegion();
                this._invoiceLayout.hideTipsRegion();
                this._invoiceLayout.hideUsedPackageInstancesRegion();
            } else {
                this._invoiceLayout.displayPaymentMessage('select_payment_processor', 'danger');
            }
        },

        _payFreeInvoice: function () {
            this._acceptTerms(this._invoiceModel);
            this._invoiceLayout.hideRecurringFlag();
            this._invoiceLayout.hideRebillingFlag();

            this._invoiceLayout.displayPayProcess(this._invoiceModel, new PaymentSystemModel({
                'id': 'free',
                'payment_system': 'free',
                'name': 'free',
                'selected': true
            }));
        },

        _onInvoiceShown: function (isReturn, paymentAllowed) {
            this._invoiceLayout.displayInvoiceData();

            var canPayStatus = ['new', 'pending', 'cancelled', 'error'];
            var status = this._invoiceModel.get('status');

            if (!this._invoiceModel.get('payment_received') && status === 'paid') {
                status = 'pending';
            }
            // an order released by the payment timeout can never be paid again: its bookings
            // are cancelled and every payment path refuses it. It can still sit in a
            // 'cancelled'/'error' status, which is otherwise payable, so without this the page
            // keeps offering a payment that cannot succeed (CY1SDEV1-4130)
            var canPay = _.contains(canPayStatus, status) && !this._invoiceModel.get('is_released_by_timeout');

            if (canPay && !isReturn && paymentAllowed) {
                if (this._invoiceModel.get('amount') > 0) {
                    this._invoiceLayout.displayPaymentProcessors(!!this._paymentProcessor);
                } else {
                    this._invoiceLayout.displayFreeButton();
                }
            } else if (canPay && !this._invoiceModel.get('payment_received') && (!isReturn || (this._invoiceModel.get('payment_processor') === 'delay' || _.contains(['error', 'cancelled'], status)))) {
                // if more than one payment system or not delay payment system
                if (this._paymentSystemCollection.length > 1 || (this._paymentSystemCollection.length === 1 && !this._paymentSystemCollection.get('delay'))) {
                    this._invoiceLayout.displayPayNowButton();
                }
            }
            if (this._invoiceModel.get('status') === 'paid' || !paymentAllowed) {
                this._invoiceLayout.displayButtons(isReturn);
            }

            if (isReturn) {
                this._invoiceLayout.displayStatusMessage(this._invoiceModel);

                if (this._invoiceModel.get('status') === 'pending') {
                    this._timer = _.delay(_.bind(function () {
                        this._invoiceModel.fetch();
                    }, this), this._timeout);
                }
                if (this._invoiceModel.get('status') === 'paid') {
                    PluginBroker.getInstance().perform('onFinishPayment', [this._invoiceLayout, {
                        id: this._invoiceModel.id,
                        booking_ids: this._invoiceModel.getBookingIds(),
                        payment_processor: this._invoiceModel.get('payment_processor')
                    }, this._invoiceModel]);

                    Utils.triggerGTEvent('paymentAccepted', {
                        'id': this._invoiceModel.get('id'),
                        'payment_processor': this._invoiceModel.get('payment_processor')
                    });

                    if (!window.sessionStorage.getItem('paidBookingDone')) {

                        Utils.sendIframePostMessage({
                            event: 'bookingDone',
                            id: this._invoiceModel.get('id'),
                            payment_processor: this._invoiceModel.get('payment_processor')
                        });

                        window.sessionStorage.setItem('paidBookingDone', true);
                    }
                }
            }
        },

        _setPaymentProcessor: function (data) {
            this._paymentProcessor = data.model;
            var currentId = this._paymentProcessor ? this._paymentProcessor.get('id') : null;
            var supportsRebilling = this._paymentProcessor ? this._paymentProcessor.get('supports_rebilling') : false;
            var storedPaymentMethod = this._paymentProcessor ? this._paymentProcessor.get('storedPaymentMethod') : false;
            var supportsRecurring = this._paymentProcessor ? this._paymentProcessor.get('supports_recurring') : false;


            this._paymentSystemCollection.each(function (m) {
                m.set('selected', m.get('id') === currentId);
            }, this);
            this._paymentMethodCollection.each(function (m) {
                m.set('selected', m.get('id') === currentId);
            }, this);

            this._setRecurringFlag(this._invoiceModel.get('require_recurring_payment_method'));
            this._setRecurringOnlyFlag(this._invoiceModel.get('require_recurring_payment_method'));
            this._setRebillingFlag(false);

            if (supportsRebilling && !storedPaymentMethod && this._invoiceModel.get('amount') > 0) {
                this._invoiceLayout.displayRebillingFlag(this._getPaymentProcessor());
                Utils.triggerGTEvent('showRebillingCheckbox');
            } else {
                this._invoiceLayout.hideRebillingFlag();
                Utils.triggerGTEvent('hideRebillingCheckbox');
            }

            if (supportsRecurring && this._invoiceModel.get('support_recurring_payment_method')) {
                this._invoiceLayout.displayRecurringFlag(this._getPaymentProcessor());
                Utils.triggerGTEvent('showRecurringCheckbox');
            } else {
                this._invoiceLayout.hideRecurringFlag();
                Utils.triggerGTEvent('hideRecurringCheckbox');
            }

            this._invoiceLayout.hidePaymentMessage();
            this._invoiceLayout.displayPaymentProcessors(!!this._paymentProcessor);
        },

        _setRecurringFlag: function (flag) {
            var paymentProcessor = this._getPaymentProcessor();
            if (paymentProcessor) {
                paymentProcessor.set('recurring', flag);
            }
        },

        _setRecurringOnlyFlag: function (flag) {
            var paymentProcessor = this._getPaymentProcessor();
            if (paymentProcessor) {
                paymentProcessor.set('recurring_only', flag);
            }
        },

        _setRebillingFlag: function (flag) {
            var paymentProcessor = this._getPaymentProcessor();
            if (paymentProcessor) {
                paymentProcessor.set('rebilling', flag);
            }
        },

        _getPaymentProcessor: function () {
            return this._paymentProcessor;
        }

    });

});
